module.exports = __webpack_public_path__ + "img/restitution-livraison-vn.66c4fce1.png";